import { render, staticRenderFns } from "./FeatureMenu.vue?vue&type=template&id=d5a9df3a&scoped=true"
import script from "./FeatureMenu.vue?vue&type=script&lang=ts"
export * from "./FeatureMenu.vue?vue&type=script&lang=ts"
import style0 from "./FeatureMenu.vue?vue&type=style&index=0&id=d5a9df3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a9df3a",
  null
  
)

export default component.exports